import { render } from "./Reactifs.vue?vue&type=template&id=491d42e4&scoped=true"
import script from "./Reactifs.vue?vue&type=script&lang=js"
export * from "./Reactifs.vue?vue&type=script&lang=js"

import "./Reactifs.vue?vue&type=style&index=0&id=491d42e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491d42e4"]])

export default __exports__